import {
    ServiceBoardServiceFetchSuccessActionType,
    ServiceBoardServiceFetchRequestActionType,
    ServiceBoardServiceFetchFailureActionType,
} from './serviceBoardServiceAction';
import { ActionType } from 'store/ActionType';
import { IServiceBoardServiceState } from 'models/serviceBoardService';
import { Service } from 'services/ApiService/ServiceBoard/ServiceBoardApiClient';

const services = (
    state: IServiceBoardServiceState,
    action: ActionType,
): IServiceBoardServiceState => {
    state ??= {
        data: {},
        accessServices: [],
        accessPages: [],
    };

    switch (action.type) {
        case ServiceBoardServiceFetchSuccessActionType:
            return mergeHasAccess({
                ...state,
                data: {
                    ...state.data,
                    [action.payload.key]: {
                        loading: false,
                        services: action.payload.services || [],
                        nonSgmServices: action.payload.nonSgmServices || [],
                    },
                },
            });

        case ServiceBoardServiceFetchRequestActionType:
            return mergeHasAccess({
                ...state,
                data: {
                    ...state.data,
                    [action.payload.key]: {
                        loading: true,
                        services: [],
                        nonSgmServices: [],
                    },
                },
            });

        case ServiceBoardServiceFetchFailureActionType:
            return mergeHasAccess({
                ...state,
                data: {
                    ...state.data,
                    [action.payload.key]: {
                        loading: false,
                        services: [],
                        nonSgmServices: [],
                    },
                },
            });

        default:
            return state;
    }
};

const mergeHasAccess = (state: IServiceBoardServiceState): IServiceBoardServiceState => {
    const allAccessibleServices = Object.keys(state.data)
        .reduce((acc, value) => [...acc, ...state.data[value].services.filter(x => x.hasAccess)], [] as Service[]);

    const accessibleServiceKeys = allAccessibleServices
        .map(x => x.serviceKey as string)
        .filter((value, index, array) => value && array.indexOf(value) === index);

    const accessiblePages = allAccessibleServices
        .map(x => x.servicePages || [])
        .reduce((acc, value) => [...acc, ...value.map(x => x.id as string)], [] as string[])
        .filter((value, index, array) => value && array.indexOf(value) === index);

    return {
        ...state,
        accessServices: accessibleServiceKeys,
        accessPages: accessiblePages,
    };
};

export default services;
